export function addQueryParams(
  url: string,
  queryParams: Record<string, string | number> = {}
) {
  const [baseUrl, existingQuery] = url.split('?');
  const searchParams = new URLSearchParams(existingQuery || '');

  for (const [key, val] of Object.entries(queryParams)) {
    searchParams.append(key, String(val));
  }

  return searchParams.toString()
    ? `${baseUrl}?${searchParams.toString()}`
    : baseUrl;
}

export function filterRecord<K extends string | number | symbol, V>(
  record: Record<K, V>,
  fn: (key: K, val: V) => boolean
): Record<K, V> {
  const result: Record<K, V> = {} as Record<K, V>;

  for (const [key, val] of Object.entries(record) as [K, V][]) {
    if (fn(key, val)) {
      result[key as K] = val;
    }
  }

  return result;
}

export function removeEmptyValues<T = any>(obj: T): T {
  if (typeof obj !== 'object' || obj === null) return obj; // Return non-objects as is

  const stack: [Record<string, any>, string, Record<string, any>][] = [
    [{}, '', obj], // Initialize stack with an empty result object
  ];
  const result: Record<string, any> = stack[0][0]; // The cleaned object

  while (stack.length > 0) {
    const [cleanedObj, parentKey, currentObj] = stack.pop()!;

    Object.entries(currentObj).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        if (typeof value === 'object' && !Array.isArray(value)) {
          const newCleanedObj = {};
          cleanedObj[key] = newCleanedObj; // Add new cleaned object
          stack.push([newCleanedObj, key, value]); // Push to stack
        } else {
          cleanedObj[key] = value; // Assign valid values directly
        }
      }
    });

    if (parentKey && Object.keys(cleanedObj).length === 0) {
      delete stack[0][0][parentKey]; // Remove empty objects
    }
  }

  return result as T;
}
